import { NestedValidationObj, ValidationObj } from 'common/types/ValidationObj';
import { ApplicationStatus } from './components/application/ApplicationStatus';
import ApplicationDetail from './types/ApplicationDetail';
import ChsAddress from './types/ChsAddress';

export enum RulesEngineStatus {
  pre = 'pre',
  pending = 'pending',
  post = 'post',
}

export function getRulesEngineStatus(application: ApplicationDetail) {
  switch (application.appStatusCd) {
    case ApplicationStatus.DRAFT:
    case ApplicationStatus.PRECHECK_PENDING:
    case ApplicationStatus.PRECHECK_FAILED:
    case ApplicationStatus.PRECHECK_APPROVED:
      return RulesEngineStatus.pre;
    case ApplicationStatus.RULES_ENGINE_PENDING:
      return RulesEngineStatus.pending;
    case ApplicationStatus.RULES_ENGINE_COMPLETE:
    default:
      return RulesEngineStatus.post;
  }
}

export function validateAddress(address: ChsAddress | null | undefined) {
  const errors: ValidationObj = {
    meta: undefined,
    houseNumber: undefined,
    halfNumber: undefined,
    streetDir: undefined,
    streetName: undefined,
    streetType: undefined,
    unitNumber: undefined,
    city: undefined,
    state: undefined,
    zipCode: undefined,
    country: undefined,
    createdBy: undefined,
    createdDate: undefined,
    modifiedBy: undefined,
    modifiedDate: undefined,
    unitType: undefined,
    singleFamilyHome: undefined,
  };

  const zipRegex = /^[\d]{5}$/;

  if (!address) {
    errors.meta = 'Please select or enter an address.';
    return errors as ValidationObj;
  }

  if (address.houseNumber) {
    if (
      isNaN(parseInt(address.houseNumber)) ||
      parseInt(address.houseNumber) < 0
    ) {
      errors.houseNumber = 'House number must be a positive number.';
    }
    // In case user tries to use scientific notation...
    if (address.houseNumber.includes('e')) {
      errors.houseNumber = 'House number must be a valid number.';
    }
  } else {
    errors.houseNumber = 'You must provide a house number.';
  }
  if (!address.streetName) {
    errors.streetName = 'You must provide street name.';
  }
  if (address.singleFamilyHome !== 'Y') {
    if (!address.unitType) {
      errors.unitType = 'You must provide unit type.';
    }
    if (!address.unitNumber) {
      errors.unitNumber = 'You must provide unit number.';
    }
  }
  if (address.zipCode) {
    if (!zipRegex.test(address.zipCode)) {
      errors.zipCode = 'Zip must be 5 digits long.';
    }
  } else {
    errors.zipCode = 'You must provide zip.';
  }

  return errors as ValidationObj;
}

export function isValid(obj: ValidationObj) {
  for (const validation of Object.values(obj)) {
    if (typeof validation === 'object' && !Array.isArray(validation)) {
      // Check if value is a nested validation
      // ... and if it is nested check if it is valid
      if (!isValidNested(validation)) {
        return false;
      }
    } else if (validation) {
      // Otherwise, return false if there is an error message
      return false;
    }
  }
  return true;
}

function isValidNested(obj: NestedValidationObj) {
  for (const value of Object.values(obj)) {
    if (value) {
      return false;
    }
  }
  return true;
}
